import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/gm/quotes/$id')({
  component: GmQuoteIdLayout,
});

function GmQuoteIdLayout() {
  return <Outlet />;
}
